export default "__VITE_ASSET__e3f005b2__"